import React from 'react';
import styles from './styles.module.scss';
import Text from '@profile/src/Components/Text';
import { formatCurrency } from '@wolffun/system-currency';
import { formatDateTimeByTimestamp } from '@profile/src/utils/date';
import { formatType } from '../../utils';

const ListItemDesktop = ({
  data
}) => {
  const renderItem = item => {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id.toString(),
      className: styles.item
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.wrapValue
    }, /*#__PURE__*/React.createElement(Text, {
      numberOfLines: 1,
      className: styles.type
    }, formatType(item.type))), /*#__PURE__*/React.createElement("div", {
      className: styles.wrapValue
    }, /*#__PURE__*/React.createElement(Text, {
      className: styles.value
    }, formatCurrency(item.changedBalance, {
      withCurrency: true,
      trimWholeFraction: true
    })), !!item.timestamp && /*#__PURE__*/React.createElement(Text, {
      className: styles.subValue
    }, formatDateTimeByTimestamp(item.timestamp))));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, data.map(renderItem));
};

export default ListItemDesktop;